<template>
  <div class="qna-container">
    <div class="qna-title-box">
      <span class="qna-font-1">FAQ</span>
      <span class="qna-font-2">자주 묻는 질문</span>
      <img
        src="https://s3.ap-northeast-2.amazonaws.com/greyd.web/compressed/Q%26A.png"
        class="qna-img"
      />
    </div>

    <div class="example">
      <div class="tabs">
        <TabItem
          v-for="item in this.$i18n.t('qna')"
          v-bind="item"
          :key="item.id"
          v-model="currentId"
        />
      </div>
      <div class="contents">
        <transition>
          <section class="item" :key="currentId">
            <div class="qna-title-container">
              {{ current.qna.title }}
            </div>
            <div
              class="qna-content-container"
              v-for="(content, idx) in current.qna.contents"
              :key="content.question"
            >
              <div style="margin-bottom: 2%">
                <span style="font-size: 1.5rem; font-weight: 700"
                  >Q{{ idx + 1 }} :</span
                >
                {{ content.question }}
              </div>
              <!-- <img
                src="https://s3.ap-northeast-2.amazonaws.com/greyd.web/compressed/A.png"
                class="answer-icon"
              /> -->
              <div class="answer-box">
                <div class="answer-square">A</div>
                <div
                  class="answer-content"
                  v-if="typeof content.answer === 'object'"
                >
                  <p v-if="content.answer.title">
                    {{ content.answer.title }}
                  </p>
                  <p
                    v-for="(answer, idx) in content.answer.content"
                    :key="answer"
                  >
                    {{ idx + 1 }}. {{ answer }}
                  </p>
                </div>
                <div class="answer-content" v-else v-html="content.answer"></div>
              </div>
            </div>
          </section>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import TabItem from './Qna-Item.vue'

export default {
  name: 'Qna',
  components: { TabItem },
  props: ['language'],
  data () {
    return {
      currentId: 1,
      list: this.$i18n.t('qna')
    }
  },
  computed: {
    current () {
      return this.$i18n.t('qna').find((el) => el.id === this.currentId) || {}
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped src="@/assets/styles/qna.css"></style>
<style scoped src="@/assets/styles/qna-mobile.css"></style>



// WEBPACK FOOTER //
// src/components/renewal/components/Qna.vue